import React from "react";

export default function PartnerPaymentInfo() {
  return <div>PartnerPaymentInfo</div>;
}
